'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import { ConfirmToLoginActionTypes } from '../actions/confirmToLogin';
import { RequestStates } from '../constants/RequestStates';
const initialState = new ImmutableMap({
  verificationCode: '',
  sendVerificationCodeState: RequestStates.UNATTEMPTED,
  verifyVerificationCodeState: RequestStates.UNATTEMPTED,
  verificationCodeError: ''
});
export default handleActions({
  [ConfirmToLoginActionTypes.UPDATE_VERIFICATION_CODE](state, action) {
    return state.merge({
      verificationCode: action.payload,
      verifyVerificationCodeState: RequestStates.UNATTEMPTED
    });
  },

  [ConfirmToLoginActionTypes.SEND_VERIFICATION_CODE](state, action) {
    return state.merge({
      sendVerificationCodeState: action.payload,
      verifyVerificationCodeState: RequestStates.UNATTEMPTED,
      verificationCode: '',
      verificationCodeError: action.error
    });
  },

  [ConfirmToLoginActionTypes.VERIFY_VERIFICATION_CODE](state, action) {
    return state.merge({
      verifyVerificationCodeState: action.payload,
      sendVerificationCodeState: RequestStates.UNATTEMPTED,
      verificationCodeError: action.error
    });
  },

  [ConfirmToLoginActionTypes.VERIFICATION_CODE_ERROR](state, action) {
    return state.set('verificationCodeError', action.payload);
  },

  [ConfirmToLoginActionTypes.CLICKED_BACK_BUTTON]() {
    return initialState;
  },

  [ConfirmToLoginActionTypes.CLICKED_DISMISS_CODE_SENT_BUTTON](state) {
    return state.set('sendVerificationCodeState', RequestStates.UNATTEMPTED);
  }

}, initialState);